import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import AnimateHeight from 'react-animate-height';
export default function Collapsable(_ref) {
  let {
    children,
    closed,
    onOpen = () => {},
    onClose = () => {},
    openDelay = 0,
    closeDelay = 250,
    duration = 250,
    ...rest
  } = _ref;
  const height = closed ? 0 : 'auto';
  return /*#__PURE__*/React.createElement(AnimateHeight, _extends({}, rest, {
    height: height,
    duration: duration,
    onHeightAnimationEnd: handleTransitionEnd,
    delay: !closed ? openDelay : closeDelay
  }), children);

  function handleTransitionEnd() {
    if (closed) {
      onClose();
    } else {
      onOpen();
    }
  }
}